import moment from 'moment';
import {
  EVehicleTypes,
  IResponsibleOfConstruction
} from '../fabrication-contracts/types';
import { IFabricationProject } from '../fabrication-projects/types';
import {
  EProductType,
  IAnnealedWire,
  IFabricationOrderExtraItem,
  IFabricationProjectItem
} from '../fabrication-purchase-order/types';

// Action Types
export enum Types {
  LOAD_FABRICATION_ORDERS = 'fabricationOrders/LOAD_FABRICATION_ORDERS',
  LOAD_FABRICATION_ORDERS_SUCCESS = 'fabricationOrders/LOAD_FABRICATION_ORDERS_SUCCESS',
  LOAD_FABRICATION_ORDERS_FAILURE = 'fabricationOrders/LOAD_FABRICATION_ORDERS_FAILURE',

  LOAD_NF_FILE_FROM_FABRICATION_ORDERS = 'fabricationOrders/LOAD_NF_FILE_FROM_FABRICATION_ORDERS',
  LOAD_NF_FILE_FROM_FABRICATION_ORDERS_SUCCESS = 'fabricationOrders/LOAD_NF_FILE_FROM_FABRICATION_ORDERS_SUCCESS',
  LOAD_NF_FILE_FROM_FABRICATION_ORDERS_FAILURE = 'fabricationOrders/LOAD_NF_FILE_FROM_FABRICATION_ORDERS_FAILURE',
  DOWNLOAD_NF_FILE_FROM_FABRICATION_ORDERS = 'fabricationOrders/DOWNLOAD_NF_FILE_FROM_FABRICATION_ORDERS',

  LOAD_FABRICATION_ORDERS_BY_ID = 'fabricationOrders/LOAD_FABRICATION_ORDERS_BY_ID',
  LOAD_FABRICATION_ORDERS_BY_ID_SUCCESS = 'fabricationOrders/LOAD_FABRICATION_ORDERS_BY_ID_SUCCESS',
  LOAD_FABRICATION_ORDERS_BY_ID_FAILURE = 'fabricationOrders/LOAD_FABRICATION_ORDERS_BY_ID_FAILURE',

  CLEAR_FABRICATION_ORDERS_STATE = 'fabricationOrders/CLEAR_FABRICATION_ORDERS_STATE'
}

export interface IFabricationOrder {
  id: number;
  contractNumber: string;
  orderNumber: string;
  orderStatus: EFabricationOrderStatus;
  sendDate: string;
  desiredDate: string;
  logisticObservation?: string;
  observation?: string;
  productType: EProductType;
  tower: string;
  vehicleTypes: [{ description: EVehicleTypes }];
  itens: IFabricationProjectItem[];
  projects: IFabricationProject[];
  otherPieces: IFabricationOrderOtherPiece[];
  annealedWires: IFabricationOrderAnnealedWire[];
  deliveries: IFabricationOrderDelivery[];
  solicitant: IResponsibleOfConstruction;
}

export interface ISelectedOrder {
  order?: IFabricationOrder;
  loading: boolean;
  error: boolean;
  updatedAt?: number;
}

export interface IFabricationOrdersState {
  selectedContractNumbers: string[];
  selectedStartDate: moment.Moment;
  selectedEndDate: moment.Moment;
  fabricationOrders?: IFabricationOrder[];
  selectedOrder?: ISelectedOrder;
  loading: boolean;
  error: boolean;
  contractError?: boolean;
}

export interface IFabricationOrderOtherPiece
  extends IFabricationOrderExtraItem {
  pieceDescription: string;
  steelDescription: string;
  diameterSize: string;
}

export interface IFabricationOrderAnnealedWire extends IAnnealedWire {
  description: string;
}

export enum EFabricationOrderStatus {
  ENVIADO = '1',
  CONFIRMADO = '3',
  EM_PRODUCAO = '5',
  PARCIALMENTE_FATURADO = '6',
  FATURADO = '7',
  CANCELADO = '8',
  BLOQUEADO = '9'
}

export const fabricationOrderStatusMap = new Map<
  EFabricationOrderStatus,
  string
>();
fabricationOrderStatusMap.set(EFabricationOrderStatus.ENVIADO, 'Enviado');
fabricationOrderStatusMap.set(EFabricationOrderStatus.CONFIRMADO, 'Confirmado');

fabricationOrderStatusMap.set(
  EFabricationOrderStatus.EM_PRODUCAO,
  'Em Produção'
);
fabricationOrderStatusMap.set(
  EFabricationOrderStatus.PARCIALMENTE_FATURADO,
  'Parcialmente Faturado'
);
fabricationOrderStatusMap.set(EFabricationOrderStatus.FATURADO, 'Faturado');
fabricationOrderStatusMap.set(EFabricationOrderStatus.CANCELADO, 'Cancelado');
fabricationOrderStatusMap.set(EFabricationOrderStatus.BLOQUEADO, 'Bloqueado');

export interface IFabricationOrderDelivery {
  deliveryId: number;
  description: string;
  statusId: number;
  constructionStep: string | null;
  totalWeight: number;
  scheduledDate: string;
  nfState?: INFEColumnState;
  invoices?: IFabricationOrderDeliveryInvoice[];
}

interface IFabricationOrderDeliveryInvoice {
  danfeNumber: string;
  id: number;
  issueDate: string;
}

export interface IDownloadNFEResponse {
  FILE: string;
  XML: string;
}

export interface INFEColumnState {
  downloadNFEResponse?: IDownloadNFEResponse;
  loading?: boolean;
  error?: boolean;
  alreadyDownloaded?: boolean;
}
